module.exports = __webpack_public_path__ + "img/ic_mis_check_off.661fcaa7.svg";